/**
 * InView Animation Utility
 * Handles scroll-based animations for elements with the 'inview' class
 */
export const inview = () => {
    // Configuration
    const CONFIG = {
        threshold: 0.1, // 10% of viewport height
        rootMargin: '0px',
        once: true // Only trigger animation once
    };

    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
        // Modern approach using Intersection Observer API
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('over');

                    // Unobserve if we only want to trigger once
                    if (CONFIG.once) {
                        observer.unobserve(entry.target);
                    }
                } else if (!CONFIG.once) {
                    // Remove class when element is out of view (if not once)
                    entry.target.classList.remove('over');
                }
            });
        }, {
            threshold: CONFIG.threshold,
            rootMargin: CONFIG.rootMargin
        });

        // Observe all inview elements
        const inviewElements = document.querySelectorAll('.inview');
        inviewElements.forEach((element) => {
            observer.observe(element);
        });

    } else {
        // Fallback for older browsers using scroll events
        console.warn('Intersection Observer not supported, using scroll fallback');

        const inViewFallback = (elements) => {
            const windowHeight = window.innerHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const docViewTop = scrollTop + windowHeight - (windowHeight * CONFIG.threshold);

            elements.forEach((element) => {
                if (!element.classList.contains('over')) {
                    const elemTop = element.offsetTop;

                    if (elemTop < docViewTop) {
                        element.classList.add('over');
                    }
                }
            });
        };

        // Initial check
        const inviewElements = document.querySelectorAll('.inview');
        inViewFallback(inviewElements);

        // Throttled scroll handler for better performance
        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    inViewFallback(inviewElements);
                    ticking = false;
                });
                ticking = true;
            }
        };

        // Add scroll listener
        window.addEventListener('scroll', handleScroll, { passive: true });
    }
};
